// extracted by mini-css-extract-plugin
export default {"cls1":"Office_cls1__J4PR5","cls2":"Office_cls2__aVosA","cls3":"Office_cls3__z+Pon","cls4":"Office_cls4__wSS5q","cls5":"Office_cls5__hgTx8"};